import React from 'react';
import { Box } from '@mui/material';
import Header from './Header';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        width: '100vw',
        maxWidth: '100%',
        overflow: 'hidden',
        margin: 0,
        padding: 0
      }}
    >
      <Header />
      <Box 
        component="main" 
        sx={{ 
          flexGrow: 1,
          width: '100%',
          height: 'calc(100vh - 60px)',
          overflow: 'auto',
          marginTop: '60px' // Add top margin to account for fixed header
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default Layout;
